import React from 'react';
import PropTypes from 'prop-types';
import { cn } from 'lib/utils';

function LeadPartnerCard({
  title,
  subtitle,
  selected = false,
  disabled = false,
  onClick
}) {
  return (
    <button
      type='button'
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      className={cn(
        'rounded-xl min-h-[90px] px-4 py-4 flex flex-col items-center justify-center transition-all duration-100 select-none border-2 w-full max-w-xs',
        disabled && 'cursor-default',
        !disabled && 'cursor-pointer hover:border-secondary-darkened',
        selected
          ? 'border-secondary-darkened bg-secondary-light shadow-sm'
          : 'border-grey-lighter bg-grey-lightest hover:bg-white',
        disabled && !selected && 'border-grey-lighter bg-grey-lightest'
      )}
    >
      <span className='text-md font-semibold text-black text-center wrap-break-word'>
        {title}
      </span>
      {subtitle ? (
        <span className='text-sm mt-1 font-normal text-warning-contrast'>
          {subtitle}
        </span>
      ) : null}
    </button>
  );
}

LeadPartnerCard.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func
};

export default LeadPartnerCard;
